/* eslint-disable no-undef */
/**
 * params.type = 'iframe'
 * params.gdpr_consent = '';
 * params.us_privacy = '';
 * params.gdpr_optin = [0|1]
 * @param {Object} params
 */
function buildUrlCookieSync(endpoint, params) {
  const urlEndpoint = process.env.TAPPX_URL_COOKIE_SYNC.replace('[endpoint]', endpoint);
  const url = new URL(urlEndpoint);
  const paramsData = Object.assign(params);
  paramsData.type = process.env.TAPPX_TYPE_IFRAME_COOKIE_SYNC;
  paramsData.gdpr_optin = params.gdpr_consent ? 1 : 0;
  url.search = new URLSearchParams(params).toString();
  return url;
}

function inyectIframe(urlTappxCookieSync) {
  const iframeContainer = document.createElement('iframe');
  const idCookieFrame = '2032b3863dafb3c';

  iframeContainer.setAttribute('sandbox', 'allow-scripts allow-same-origin');
  iframeContainer.setAttribute('frameborder', '0');
  iframeContainer.setAttribute('allowtransparency', 'true');
  iframeContainer.setAttribute('marginheight', '0');
  iframeContainer.setAttribute('marginwidth', '0');
  iframeContainer.setAttribute('width', '0');
  iframeContainer.setAttribute('height', '0');
  iframeContainer.setAttribute('hspace', '0');
  iframeContainer.setAttribute('vspace', '0');
  iframeContainer.setAttribute('scrolling', '0');
  iframeContainer.setAttribute('vspace', '0');
  iframeContainer.id = idCookieFrame;
  iframeContainer.src = urlTappxCookieSync;
  iframeContainer.style.width = '0px';
  iframeContainer.style.height = '0px';
  iframeContainer.style.display = 'none';

  document.body.appendChild(iframeContainer);
}

function addCookieSync(endpoint, params) {
  const urlTappxCookieSync = buildUrlCookieSync(endpoint, params);
  inyectIframe(urlTappxCookieSync);
}

export default {
  addCookieSync,
  buildUrlCookieSync,
};
